import DrawTheKing from "../Views/DrawTheKing";

const routes = [{ path: "/draw-the-king", element: <DrawTheKing /> }];

export default routes;
